import { string, object, SchemaOf } from 'yup'

export interface IResetPasswordSchema {
    password: string
    passwordConf: string
}

const resetPasswordSchema: SchemaOf<IResetPasswordSchema> = object().shape({
    password: string().required('Preencha o campo com a nova senha.').max(20, 'Máx 20 caracteres'),
    passwordConf: string().required('Preencha o campo com a confirmação da nova senha.').max(20, 'Máx 20 caracteres'),
})

export default resetPasswordSchema
